import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export const ProgressBar = ({ videoRef, buttons }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  useEffect(() => {
    videoRef.addEventListener("timeupdate", updateRemainingTime);
    return () => {
      videoRef.removeEventListener("timeupdate", updateRemainingTime);
    };
  }, []); //eslint-disable-line
  /* c8 ignore next 3 */
  const updateRemainingTime = () => {
    setRemainingTime(videoRef.duration - videoRef.currentTime);
  };
  const handleSetVideoInCustomPosition = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = x / rect.width;
    videoRef.currentTime = videoRef.duration * percentage;
  };
  const parseTimePassedNumberToTime = () => {
    const minutes = Math.floor((videoRef.duration - remainingTime) / 60);
    const seconds = Math.floor((videoRef.duration - remainingTime) % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <>
      {buttons.progress_bar ? (
        <div
          className={"ITXVideo__actionBar_progress"}
          data-testid={"progressbar"}
          onClick={handleSetVideoInCustomPosition}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              handleSetVideoInCustomPosition(e);
            }
          }}
        >
          <div className={"ITXVideo__actionBar_current"}>
            <span
              style={{
                width: `${(videoRef.currentTime / videoRef.duration) * 100}%`,
              }}
            ></span>
            <div className={"ITXVideo__actionBar_current__time"}>
              <div className={"elapsed"}>
                <span>{parseTimePassedNumberToTime()}</span>
              </div>
              <span />
            </div>
          </div>
        </div>
      ) : (
        <div className={"ITXVideo__actionBar_progress"}></div>
      )}
    </>
  );
};
ProgressBar.propTypes = {
  buttons: PropTypes.shape({
    progress_bar: PropTypes.bool.isRequired,
  }).isRequired,
  videoRef: PropTypes.object.isRequired,
};
